import { render, staticRenderFns } from "./MarketplaceSKULabel.vue?vue&type=template&id=653da1b2&scoped=true&"
import script from "./MarketplaceSKULabel.vue?vue&type=script&lang=js&"
export * from "./MarketplaceSKULabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653da1b2",
  null
  
)

export default component.exports